import { render, staticRenderFns } from "./settings-account.vue?vue&type=template&id=c384616a"
import script from "./settings-account.vue?vue&type=script&lang=js"
export * from "./settings-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports